// Clonar grupo ou item do orçamento (Rafael, 07/10): para não redigitar tudo de novo.
//
// O clone copia o que foi DIGITADO (produto, fornecedor, quantidades, diárias, valores, moeda,
// câmbio, forma/prazo de pagamento, observações…) e nasce como linha NOVA: sem id, com chaves novas
// e sem nada que pertença à linha original no Financeiro (NF, anexos, adiantamento, fechamento do
// exterior, aéreo vinculado, valores realizados). A API trata linha sem id como criação.
//
// Não se clona o que o sistema monta sozinho (duplicaria): grupo Agência, linha do FEE da Agência,
// FEE Sanofi e Imposto NF Access (1945) — essas decisões chegam prontas em `podeClonar…`.

import { itemExigeObservacao, CAMPOS_OBSERVACAO } from './observacaoObrigatoriaPolicy';

// Campos da linha original que NÃO vão para o clone.
export const CAMPOS_NAO_CLONADOS = [
    'id', 'superior', 'ordem', 'orcamento', 'grupoTitulo', 'created_at', 'updated_at', 'deleted_at',
    // documentos e anexos são da linha original
    'arquivonotafiscal', 'pagamentoentreganf', 'arquivoequipamentos',
    // Financeiro / execução da linha original
    'valor_adiantamento_item', 'pagamentovalorreal', 'pagamentosavingreal',
    'fechamento_exibicao', 'fechamento_exterior_calculado', 'fee_fechamento_real_calculado',
    'remessa_estimativa_calculada', 'evento_aereo_id',
    // histórico de taxonomia da linha original
    'produto_anterior', 'taxonomia_revisar',
];

const ehCampoTemporario = (chave) => chave.startsWith('binarios') || chave.startsWith('remover');

export function clonarSubitem(subitem, gerarChave) {
    const clone = JSON.parse(JSON.stringify(subitem || {}));
    CAMPOS_NAO_CLONADOS.forEach((campo) => { delete clone[campo]; });
    Object.keys(clone).filter(ehCampoTemporario).forEach((campo) => { delete clone[campo]; });
    clone.fechamento_exterior = null;
    delete clone.produtoTrocadoNaTela;
    // Item com observação obrigatória (Palestrante, Sala Evento, Brinde...; 21/10): o Clonar é o "adicionar
    // outro" — a cópia nasce sem observação para o usuário dizer quem/qual é o novo.
    if (itemExigeObservacao(clone.produto)) CAMPOS_OBSERVACAO.forEach((campo) => { clone[campo] = ''; });
    clone.chaveunica = gerarChave();
    clone.chavessomar = '';
    return clone;
}

export function clonarGrupo(grupo, gerarChave) {
    const clone = clonarSubitem({ ...(grupo || {}), subitem: undefined }, gerarChave);
    clone.chavegrupo = gerarChave();
    clone.subitem = ((grupo && grupo.subitem) || []).map((s) => clonarSubitem(s, gerarChave));
    return clone;
}

// Grupos abertos são guardados por índice: inserir na posição `posicao` empurra os de baixo e
// abre o clone (o operador vê na hora o que foi copiado).
export function expandidosAposInserir(expandidos, posicao) {
    if (!Array.isArray(expandidos)) return expandidos;
    return [...expandidos.map((i) => (i >= posicao ? i + 1 : i)), posicao];
}

// Produto inativo no catálogo (taxonomia 2026): a linha antiga continua valendo, mas a API recusa
// linha NOVA com ele (trava de grupo/taxonomia) — então o clone nem é oferecido.
export const MSG_CLONAR_PRODUTO_INATIVO = 'Produto inativo no catálogo 2026: não pode ser clonado. Escolha um produto ativo.';
export function produtoInativo(registro) {
    const situacao = registro && registro.produto && registro.produto.situacaoRegistro;
    return !!situacao && String(situacao).toLowerCase() !== 'ativo';
}
